import { render, staticRenderFns } from "./ContractUpload.vue?vue&type=template&id=2b2563f4&scoped=true&"
import script from "./ContractUpload.vue?vue&type=script&lang=js&"
export * from "./ContractUpload.vue?vue&type=script&lang=js&"
import style0 from "./ContractUpload.vue?vue&type=style&index=0&id=2b2563f4&prod&lang=scss&scoped=true&"
import style1 from "./ContractUpload.vue?vue&type=style&index=1&id=2b2563f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2563f4",
  null
  
)

export default component.exports